export default __webpack_public_path__ + "images/9c768e2663d2f996a617143a2ef8c9af-parents_association.jpg";